import React from "react";

const normalizeTone = (value = "") => {
  if (["paid", "delivered", "done", "active"].includes(value)) return "success";
  if (["partial", "medium", "in_progress", "design_review", "quality_check"].includes(value)) return "warning";
  if (["unpaid", "urgent", "overdue", "cancelled"].includes(value)) return "danger";
  return "neutral";
};

const StatusBadge = ({ value }) => (
  <span className={`status-badge status-badge--${normalizeTone(value)}`}>
    {String(value || "").replaceAll("_", " ")}
  </span>
);

export default StatusBadge;
